import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import styled, { css } from 'styled-components';
import { styles } from '../Input/Input.styles';

const Styles = css`
  .react-select__control {
    ${styles}
    color: var(--text-main);
    min-height: inherit;
    padding-top: 0;
    padding-bottom: 0;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    border-color: ${({ error }) => error && 'var(--danger) !important'};
    box-shadow: none;
    ${({ $gray }) =>
      $gray &&
      css`
        background: var(--gray);
      `}
    &:hover {
      border-color: var(--border);
    }
    &.react-select__control--is-focused,
    &.react-select__control--menu-is-open {
      border-color: var(--primary);
      font-size: 14px;
      color: var(--text-main);
      background-color: var(--surface);
      box-shadow: 0 0 0 4px var(--o-halo);
    }
  }
  .react-select__placeholder {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: calc(100% - 8px);
    color: var(--text-muted);
  }
  .react-select__value-container {
    padding-left: 0;
    padding-right: 0;
  }
  .react-select__menu {
    box-shadow: 0 8px 24px rgba(28, 25, 23, 0.1);
    border-radius: 8px;
    border: 1px solid var(--border);
    z-index: 9;
    color: var(--text-main);
    background-color: var(--surface);
  }

  .react-select__single-value {
    color: var(--text-main);
  }

  .react-select__option {
    font-size: 14px;
    cursor: pointer;
    color: var(--text-main);

    &:active {
      color: var(--text-main);
      background: var(--gray);
    }
  }
  .react-select__option--is-focused {
    color: var(--text-main);
    background: rgba(255, 75, 20, 0.12);
  }
  .react-select__option--is-selected {
    color: var(--primary-foreground);
    background: var(--primary);
  }

  .react-select__indicator,
  .react-select__dropdown-indicator,
  .css-1xc3v61-indicatorContainer {
    color: var(--text-muted) !important;
    svg {
      width: 16px;
    }
  }

  ${({ isMulti }) =>
    isMulti &&
    css`
      .react-select__control {
        height: auto;
        min-height: 45px;
        font-size: 14px;
      }
      .react-select__option {
        position: relative;
        /* font-size: 14px; */
        padding-left: 42px;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 14px;
        text-transform: uppercase;

        &:before,
        &:after {
          content: '';
          position: absolute;
          left: 14px;
          top: 50%;
          transform: translateY(-50%);
          border: 1px solid var(--primary);
          border-radius: 5px;
          width: 16px;
          height: 16px;
        }
        &:hover {
          &:before,
          &:after {
            border: 1px solid var(--primary);
          }
        }
        &:after {
          content: '\\e876';
          font-family: 'Material Icons Round';
          background: var(--primary);
          opacity: 0;
          visibility: hidden;
          transition: 0.3s linear;
          color: var(--white);
          /* font-size: 10px; */
          line-height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &.react-select__option--is-selected {
          background: none;
          color: #0f2546;
          &:after {
            opacity: 1;
            visibility: visible;
          }
          &.react-select__option--is-focused {
            background: var(--light-secondary);
          }
        }
      }
      .react-select__multi-value {
        background: var(--o-tint);
        /* font-size: 12px; */
        line-height: 12px;
        border-radius: 60px;
        color: var(--ink);
        border: 1px solid var(--line);
      }
      .react-select__multi-value__label {
        color: var(--ink);
      }
      .react-select__multi-value__remove {
        color: var(--quiet);
        &:hover {
          background: transparent;
          color: var(--o2);
        }
      }
    `}
`;

export const StyledSelect = styled(Select)`
  ${Styles}
`;

export const StyledSelectAsync = styled(AsyncSelect)`
  ${Styles}
`;
